export default __webpack_public_path__ + "static/Spitz_Germany_banner-df6cff27648da088a953b795622e94eb.jpg";